import { createReducer, on } from '@ngrx/store';
import { filter, loadMatchesFailure, loadMatchesSuccess, resetFilters, selectMatch } from './fixtures.actions';
import { StoreState } from '../index';
import { StreamPlayItem } from '@streamamg/stream-play-lib/src/lib/types/stream-play.type';

export const featureKey = 'fixtures';

export interface State extends StoreState {
  selectedMatchId?: number;
  fixtures?: StreamPlayItem[];
  filters?: FixturesFilters;
}

export interface FixturesFilters {
  team?: string;
  date?: {
    from?: Date;
    to?: Date;
  };
}

export const initialState: State = {
  filters: {},
};

export const reducer = createReducer(
  initialState,
  on(loadMatchesSuccess, (state, {data}) => ({
    ...state,
    fixtures: data,
    status: {...initialState.status, ready: true},
  })),
  on(loadMatchesFailure, (state, {error}) => ({...state, status: {loading: false, error, ready: true}})),
  on(resetFilters, (state) => ({...state, filters: {...initialState.filters}})),
  on(filter, (state, filters) => ({...state, filters})),
  on(selectMatch, (state, {matchId}) => ({...state, selectedMatchId: matchId})),
);

